import styled from 'styled-components';
import Label from '@minecraft.label';
import { media } from '@minecraft.themes';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';
import Row from '@minecraft.row';
import UncontrolledRadioGroup from '@minecraft.uncontrolled-radio-group';
import FormikUncontrolledRadioGroup from '@minecraft.formik-uncontrolled-radio-group';
import Button from '@minecraft.button';
import Alert from '@minecraft.alert';

export const LoaderWrap = styled.div<{ $whiteBackground: boolean }>`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  background-color: ${(props): string => (props.$whiteBackground ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.3)')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLoadingNotes = styled.p`
  position: absolute;
  top: 50%;
  padding-top: 2rem;
`;

export const StyledLoadingNote = styled.div`
  text-align: center;
  line-height: 1.2;
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.primary.white};
  background-color: ${props => props.theme.colors.accent.red};
  margin: 0.625rem 1.375rem;
  padding: 0.1rem 1.375rem;
  font-size: 1rem;
  vertical-align: middle;
`;

export const AlignCenter = styled.div`
  text-align: center;
`;

export const UnderlinedLink = styled.a`
  text-decoration: underline;
`;

export const GridWrapper = styled.div`
  max-width: 90rem;
  width: 100%;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;

  ${media.md`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-areas: 'back main';
  `}
`;

export const Container = styled.div`
  max-width: 78.25rem;
  width: 100%;
  margin: 0 auto;
  line-height: normal;
`;

export const StartContainer = styled.div`
  padding: 1rem 1rem 2rem;
  max-width: 47.375rem;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${media.md`
    padding: 3rem 1rem 1rem;
  `}
`;

export const GridStartContainer = styled(StartContainer)`
  margin: 0 auto;
  grid-area: main;
  grid-column: 2/12;
`;

export const PageHeader = styled.h1`
  font-size: 1.375rem;
  margin-bottom: 0.5rem;

  ${media.sm`
    font-size: 1.4667rem;
  `}

  ${media.md`
    font-size: 1.5rem;
    margin-bottom: 1rem;
  `}
`;

export const PageSubHeader = styled.h1`
  font-size: 1.25rem;
  margin-bottom: 1.1875rem;
  font-weight: 500;
`;

export const PageText = styled.p`
  font-size: 1rem;
  line-height: normal;
`;

export const ExternalLink = styled.a`
  color: ${(props): string => props.theme.colors.primary.primary};

  &:active,
  &:visited,
  &:focus,
  &:hover {
    color: ${(props): string => props.theme.colors.primary.primary};
  }
`;

export const StyledLabel = styled(Label)`
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  line-height: normal;
  color: ${(props): string => props.theme.colors.primary.darkGrey};
`;

export const StyledLabelNoMargin = styled(StyledLabel)`
  margin-bottom: 0rem;
`;

export const PhoneStyledLabel = styled(StyledLabel)`
  margin-left: 2.5rem;
`;

export const SubLabel = styled.div`
  font-style: italic;
  font-size: 0.75rem;
  line-height: normal;
  margin-bottom: 0.5rem;
`;

export const InputSubText = styled.div`
  font-size: 0.85rem;
  line-height: normal;
  margin-top: 0.2rem;
`;

export const AgreementStyledCheckbox = styled(FormikSimpleCheckbox)`
  & + span {
    border-color: ${(props): string => (props.error ? props.theme.colors.accent.red : '')} !important;
    font-size: 0.875rem;
  }
`;

export const ButtonWrapRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonWrapRightBottom = styled(ButtonWrapRight)`
  margin-top: auto;

  ${media.md`
    margin-top: 0;
  `};
`;

export const SmWideButton = styled(Button)`
  width: 100%;

  ${media.md`
    width: auto;
  `};
`;

export const FieldStylesRow = styled(Row)`
  margin-top: 1.2rem;
  margin-bottom: 1.2rem;
  position: relative;
`;

export const FieldStylesRowWithMargin = styled(FieldStylesRow)`
  margin-top: 21rem;
`;

export const FieldStylesRowSpace = styled(FieldStylesRow)`
  display: flex;
  justify-content: space-between;
`;

export const StyledRadioGroup = styled(UncontrolledRadioGroup)`
  padding: 1rem 1rem 1rem 2.8125rem;
  border: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
  border-radius: 0.25rem;
  width: 100%;

  &.active {
    background-color: #eef7ff; //--TODO: need to add in minecraft;
    border: 2px solid ${(props): string => props.theme.colors.accent.blueActive};
  }

  span {
    top: 50%;
    transform: translateY(-50%);
    left: 1rem;
  }

  ${media.md`
    padding: 1.5rem 1.5625rem 1.5rem 3.3125rem;

    span {
    left: 1.5625rem;
  }
  `}
`;

export const StyledCheckbox = styled.div`
  margin-bottom: 2.5rem;

  label {
    padding: 1rem 1rem 1rem 2.8125rem;
    border: ${(props: any): string =>
      props.active
        ? `2px solid ${props.theme.colors.accent.blueActive}`
        : `1px solid ${props.theme.colors.primary.ltGrey1}`};
    border-radius: 0.25rem;
    background-color: ${(props: any): string => (props.active ? '#eef7ff' : props.theme.colors.primary.white)};
    width: 100%;

    span {
      top: 50%;
      transform: translateY(-50%);
      left: 1rem;
    }

    ${media.md`
    padding: 1.5rem 1.5625rem 1.5rem 3.3125rem;

    span {
    left: 1.5625rem;
  }
  `}
  }
`;

export const StyledFormikUncontrolledRadioGroup = styled(FormikUncontrolledRadioGroup)`
  padding: 0;
  background-color: ${(props): string => props.theme.colors.primary.white};
  border: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
  border-radius: 0.25rem;
  width: 100%;

  &.active {
    background-color: #eef7ff; //--TODO: need to add in minecraft;
    border: 2px solid ${(props): string => props.theme.colors.accent.blueActive};

    .card {
      background-color: transparent;
    }
  }

  .card {
    border: 0;
  }

  span {
    top: 1rem;
    left: 1rem;
  }

  ${media.sm`
    width: auto;

    &:not(:nth-child(2n)) {
      margin-right: calc((100% - (13.25rem + 4px) * 2));
    }

    span {
    top: 0.5rem;
    left: 0.5rem;
  }

  `}

  ${media.md`
    width: auto;

    &:not(:nth-child(2n)) {
      margin-right: 0;
    }

    &:not(:nth-child(3n)) {
      margin-right: calc((100% - (13.25rem + 4px) * 3) / 2);
    }
  `}
`;

export const StyledRadioGroupWithSubText = styled(UncontrolledRadioGroup)`
  width: 100%;
  margin-bottom: 0.875rem;
  label {
    margin: 0;
  }
  .label-with-sub {
    padding: 0.75rem 1rem 0.85rem 3rem;
    border: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
    border-radius: 0.25rem;
    width: 100%;

    &.active {
      background-color: #eef7ff; //--TODO: need to add in minecraft;
      border: 2px solid ${(props): string => props.theme.colors.accent.blueActive};
    }

    span {
      top: 50%;
      transform: translateY(-50%);
      left: 1rem;
    }

    ${media.md`
      padding: 1rem 1rem 1rem 3rem;
    `}
  }
  .radio-sub-text {
    font-size: 0.875rem;
    color: ${(props): string => props.theme.colors.primary.grey1};
    font-style: italic;
  }
`;

export const BaseballFormikCheckbox = styled.div`
  width: 100%;

  label {
    padding-left: 0;

    & > span {
      margin: 0.5rem 0 0 0.5rem;
    }
  }

  ${media.sm`
    width: auto;
    &:not(:nth-child(2n)) {
      margin-right: calc((100% - 13.5rem * 2));
    }
  `}

  @media (min-width: 55rem) {
    &:not(:nth-child(2n)) {
      margin-right: 0;
    }

    &:not(:nth-child(3n)) {
      margin-right: calc((100% - 13.5rem * 3) / 2);
    }
  }
`;

export const ItalicText = styled.span`
  font-style: italic;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const TextFromMD = styled.span`
  display: none;
  ${media.md`
    display: inline-block;
  `}
`;

export const StyledAlert = styled(Alert)`
  height: 3.75rem;
  position: fixed;
  top: 0;
`;
